import React from "react";
import { strings } from "../resources/strings";
import { formatString } from "../utils/UtilityFunctions";

const currentYear = new Date().getFullYear();

function Footer() {
  return (
    <footer className="footer mt-auto  p-4 text-slate-500 bg-transparent">
      <div className="items-center grid-flow-col">
        <p>{formatString(strings.copyright, String(currentYear))}</p>
      </div>
    </footer>
  );
}

export default Footer;
